export function contentGenerartor(type) {
  if (type === "collection") {
    return {
      title: "انتخاب آدرس و زمان جمع‌آوری",
      actionButton: "تایید",
    };
  }
  return {
    title: "انتخاب آدرس و زمان تحویل",
    actionButton: "تایید",
  };
}
